import styled from "styled-components";

export const Wrapper = styled.div`
    max-width: 500px;
    margin: 100px auto;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 30px;
    border-radius: 20px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
`;